import _ from 'lodash';

const TimeUtils = {
  timingsOnDay: (timings, day) =>
    _.find(timings, timing => timing.weekday === day),

  shortWeekday: weekday =>
    _.truncate(_.toUpper(weekday), { length: 3, omission: '' }),

  timeToHuman: (time) => {
    const parts = _.split(time, ':', 2);
    const hour = _.parseInt(_.first(parts));
    const minutes = _.last(parts);
    const humanHour = `${hour % 12 || 12}:${minutes}`;
    return hour > 11 ? `${humanHour} PM` : `${humanHour} AM`;
  },
  showTimeRange: (openingTime, closingTime) =>
    `${TimeUtils.timeToHuman(openingTime)} -
     ${TimeUtils.timeToHuman(closingTime)}`,
};

export default TimeUtils;



// WEBPACK FOOTER //
// ./utils/time.js